import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getBlogs } from "../../../utils/API"; 
import blog1 from "../../../assets/frontendassets/BlogsImages/1.png";
import blog2 from "../../../assets/frontendassets/BlogsImages/2.png";
import blog3 from "../../../assets/frontendassets/BlogsImages/3.png";
import { Col, Row, Breadcrumb, Carousel } from 'antd';


const BlogDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const [blogDetail, setBlogDetail] = useState<any | null>(null);
  const [blogssData, setBlogssData] = useState<any>([]);
 const [blogsData, setBlogsData] = useState<any[]>([]);  // Corrected setBlogsData
 
  useEffect(() => {
    const BlogsData = async () => {
      try {
        const response = await getBlogs();
        console.log("response", response)
        if (response.blogs && response.blogs.length > 0) {
          setBlogssData(response.blogs);
        }
      } catch (error) {
        console.error("Error fetching setting data:", error);
      }
    };

    BlogsData();
  }, []);

  useEffect(() => {
    if (slug) {
      console.log("blogssData", blogssData)
      const blog = blogssData.find((item: any) => item.slug === slug);
      console.log("slug", slug);
      console.log("blog", blog);
      setBlogDetail(blog || null);
    }
  }, [slug, blogssData]);


    useEffect(() => {
      const BlogsData = async () => {
        try {
          const response = await getBlogs();
          if (response.blogs && response.blogs.length > 0) {  // Ensure correct property
            console.log(response.blogs);
            setBlogsData(response.blogs);
          }
        } catch (error) {
          console.error("Error fetching blog data:", error);
        }
      };
  
      BlogsData();
    }, []);

  if (!blogDetail) {
    return <div className="mt-36 py-3 text-center text-lg font-semibold">Blog not found</div>;
  }
  const contentSections = blogDetail.content.filter((section: any) => section.section !== 'Conclusion');
  const conclusionSection = blogDetail.content.find((section: any) => section.section === 'Conclusion');
  return (
    <div className='pt-24 sm:mt-4 sm:pt-4 bg-[#FFF8EC] sm:px-4 sm:pb-4 md:pt-6 md:px-6 md:pb-6 xl:pt-16 xl:px-24 xl:pb-8 '>
  <div className="flex flex-col md:flex-row items-center justify-center md:justify-start mt-4 sm:mt-2 space-y-2 md:space-y-0 md:space-x-4">
  {/* Horizontal Line */}
  <hr className="w-16 sm:w-24 md:w-32 lg:w-44 h-[2px] bg-black " />

  {/* Heading */}
  <h1 className="text-[18px] sm:text-[20px] md:text-[22px] font-normal flex items-center mt-2  text-center md:text-left">
    FROM THE BLOG
  </h1>
</div>

  <h1 className='text-b lack text-xl sm:text-[30px] mb-10 mt-[25px] '>Latest news & articles from the blog</h1>
  <p className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px] mt-4 text-center sm:text-left sm:mx-6 md:mx-12 lg:mx-24 xl:mx-48">
    
  </p>

  <div
    className="w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[416px] bg-cover relative pt-6 rounded-[20px]"
    style={{
      backgroundImage: `linear-gradient(to top, rgba(249, 177, 56, 1), rgba(217, 217, 217, 0) 50%), url(${process.env.REACT_APP_IMAGE_URL}/blog/${blogDetail.image})`,
    }}
  >
    <p className='absolute font-bold bottom-4 text-[16px] sm:text-[18px] md:text-[22px] lg:text-[25px] px-4'>
      {blogDetail.title}
    </p>
  </div>

  <div className="mt-6 px-2 sm:px-2 md:px-2 lg:px-2">
    <p className="text-[20px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-relaxed text-justify">
      {blogDetail.description}
      </p>
  </div>


  <div className="py-8 px-2 sm:px-2 md:px-2 lg:px-2">
 
<div className="space-y-12 mt-8">
{blogDetail.content.map((section: any, index: number) => (
  <Row gutter={16} className="w-full justify-between" justify={"space-between"} key={index}>
    {/* Image Column */}
    <Col 
      span={24} 
      lg={12} 
      xs={24} // Ensures full width on mobile
      order={index % 2 === 0 ? 1 : 0} 
    >
      {section.image && (
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/blog/${section.image}`}
          alt={`Blog section ${index}`}
          className="w-full sm:h-[251px] lg:h-[251px] xl:h-[251px] object-cover rounded-lg"
        />
      )}
    </Col>

    {/* Description Column */}
    <Col 
      span={24} 
      lg={12} 
      xs={24} // Ensures full width on mobile
      order={index % 2 === 0 ? 0 : 1} 
      className={
        `mt-auto mb-auto ${index % 2 === 0 ? "!pr-10" : "!pl-10"} `
      }
    >
      <div className={`w-full ${index % 2 === 0 ? "text-left" : "text-left"}`}>
        <h3 className="text-[22px] sm:text-xl md:text-2xl lg:text-2xl font-bold text-black inline">
          {index + 1}&nbsp;{section.section}&nbsp;
        </h3>
        <span
          className="text-black text-[22px] sm:text-base md:text-lg lg:text-xl text-justify inline"
          dangerouslySetInnerHTML={{
            __html: section.description,
          }}
        />
      </div>
    </Col>
  </Row>
))}

</div>


    {blogDetail.conclusion && (
      <div className="mt-12">
        <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-orange-500 text-center mb-4">
          {blogDetail.conclusion.title}
        </h3>
        <p className="text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl text-justify">
          <div
            dangerouslySetInnerHTML={{
              __html: blogDetail.conclusion.description,
            }}
          />
        </p>
      </div>
    )}
  </div>

    <Row align={"middle"} gutter={16} className='mb-6 p-2'>
    <Col span={4} className="flex justify-center md:justify-start">
    <hr className="w-48 sm:w-44 md:w-44 lg:w-48 border-t-2 border-black" />
  </Col>

  {/* Text */}
  <Col>
    <p className="text-[16px] sm:text-[18px] md:text-[22px] lg:text-[25px]">
      NEXT BLOGS
    </p>
  </Col>

    <Col span={24}>
  <Carousel slidesToShow={2} autoplay dots={false} draggable>
    {blogssData.length > 0 ? (
      blogssData
        .filter((blog: any) => blog.slug !== slug) // Exclude the current blog
        .map((blog: any, index: number) => (
            <Link to={`/blog/${blog.slug}`} key={index}>
           <Row
  gutter={[16, 16]}
  key={index}
  className="flex justify-center items-center p-4"
>
  <div
    className="w-full h-[150px] sm:h-[250px] md:h-[250px] lg:h-[350px] bg-cover bg-center relative mt-6 rounded-[20px]"
    style={{
      backgroundImage: `linear-gradient(to top, rgba(249, 177, 56, 1), rgba(247, 210, 120, 0.5) 30%, rgba(217, 217, 217, 0) 70%), url(${process.env.REACT_APP_IMAGE_URL}/blog/${blog.image})`,
    }}
  >
    <p
      className="absolute bottom-4 font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] px-4 text-black truncate-title"
     
      style={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        WebkitLineClamp: 2, // This will limit the text to two lines
        textOverflow: 'ellipsis',
        lineHeight: '1.5rem', // Adjust line height for readability
      }}
    >
      {blog.title}
    </p>
  </div>
</Row>

          </Link>
        ))
    ) : (
      <div className="text-center py-20">
        <p className="text-gray-500 text-lg">No blogs available</p>
      </div>
    )}
  </Carousel>
</Col>

    </Row>
</div>

  );
};

export default BlogDetail;